import moment from 'moment-timezone';

export function buildDateOnly(value: any) {
    if (value) {
        const date = moment(value as string).format('MM/DD/YYYY');
        return <span title={value}>{date.toString()}</span>;
    }
}
